module.exports = __webpack_public_path__ + "static/media/bike_mountain.6da03e99.webp";